import { usePetitionDetailsPageData } from 'src/app/pages/petitionGamma/details/pageContext';

import { useTracking } from '../../../../../hooks/useTracking';
import type { LegislativeBody } from '../../../../../shared/types';

type Result = ModelHookResult<
	{
		title: string;
		petitionAsk: string;
	},
	{
		trackViewAllDMsWithinLegislativeBodyClick: (role: string) => void;
	}
>;

export function useViewMore(legislativeBody: LegislativeBody): Result {
	const {
		data: {
			petition: { ask },
		},
	} = usePetitionDetailsPageData();
	const { trackViewAllDMsWithinLegislativeBodyClick } = useTracking();

	return {
		data: {
			title: `Decision Makers: ${legislativeBody.title}`,
			petitionAsk: ask,
		},
		actions: {
			trackViewAllDMsWithinLegislativeBodyClick,
		},
	};
}
